import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "mb-5"
};
const _hoisted_2 = {
  class: "py-8 px-10"
};
const _hoisted_3 = {
  class: "block pb-8"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "flex flex-row"
};
const _hoisted_7 = {
  key: 2
};
const _hoisted_8 = {
  key: 3
};
import { reactive, onMounted, computed } from 'vue';
import LlButtonToggle from '@/components/LlButtonToggle.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import MaxioSubscriptionList from './MaxioSubscriptionList.vue';
import MaxioSelectedPlan from './MaxioSelectedPlan.vue';
import { useMaxioSubscriptionStore } from './useMaxioSubscriptionStore';
import VerifyBankAccountModel from './VerifyBankAccountModel.vue';
export default {
  __name: 'MaxioCompanySubscriptionPlan',
  props: {
    userService: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    },
    subscription: {
      type: Object,
      required: true
    },
    isSmallScreen: {
      type: Boolean,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    }
  },
  emits: ['selectedSubscriptionPlan'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const companySubscriptionPlan = reactive({
      saving: false,
      products: {},
      changing: false,
      editEmail: false,
      selectedProduct: undefined,
      selectedIntervalToggle: 'Annual',
      pickDifferentPlan: false,
      cardColor: '#F3F4F6',
      openVerifyBankAccountModel: false,
      isPlanSelected: false,
      routeService: {},
      me: {},
      hasPaymentInformation: computed(() => {
        const hasCardInfo = maxioCompanySubscriptionStore.subscription?.card;
        const hasBankInfo = maxioCompanySubscriptionStore.subscription?.bank;
        return hasCardInfo || hasBankInfo;
      }),
      isAwaitingSubscription: computed(() => {
        return maxioCompanySubscriptionStore.isAwaitingSubscription || maxioCompanySubscriptionStore.isCanceledSubscription;
      })
    });
    const intervals = [{
      label: 'Annual',
      value: 'Annual'
    }, {
      label: 'Monthly',
      value: 'Monthly'
    }];
    const emit = __emit;
    const maxioCompanySubscriptionStore = useMaxioSubscriptionStore();
    maxioCompanySubscriptionStore.alerts = props.alerts;
    const interval = computed(() => companySubscriptionPlan.selectedIntervalToggle === 'Monthly' ? 'monthly' : 'yearly');

    // Firms on a custom plan always stay on the overview - their subscription is managed directly in
    // Maxio by an account manager, so they never get the plan picker. Their plan can also come back
    // empty if the Maxio setup has no license component, hence the isCustomPlan check standing alone.
    const showSelectedPlan = computed(() => props.subscription?.isCustomPlan || props.subscription?.plan?.id && !companySubscriptionPlan.pickDifferentPlan);
    onMounted(async () => {
      companySubscriptionPlan.me = await props.userService.getMe();
      await listSubscriptionProducts();
    });
    const listSubscriptionProducts = async () => {
      companySubscriptionPlan.loadingProducts = true;
      try {
        const list = await maxioCompanySubscriptionStore.listSubscriptionProducts();
        companySubscriptionPlan.products = list.productFamilies;
        companySubscriptionPlan.products.forEach(p => {
          p.description = p.description.replace(/\n/g, '<br/>');
          p.products.forEach(l => {
            l.description = l.description.replace(/\n/g, '<br/>');
            if (maxioCompanySubscriptionStore.subscription.product.id === l.id) {
              companySubscriptionPlan.selectedProduct = l;
              if (l.interval === 'monthly') {
                companySubscriptionPlan.selectedIntervalToggle = 'Monthly';
              } else {
                companySubscriptionPlan.selectedIntervalToggle = 'Annual';
              }
            }
          });
        });
      } catch (err) {
        props.alerts.error(err);
      } finally {
        companySubscriptionPlan.loadingProducts = false;
      }
    };
    const intervalToggle = value => {
      companySubscriptionPlan.selectedIntervalToggle = value;
    };
    const select = product => {
      companySubscriptionPlan.selectedProduct = product;
    };
    const pickDifferentPlan = () => {
      companySubscriptionPlan.pickDifferentPlan = true;
      if (maxioCompanySubscriptionStore?.subscription?.product) {
        companySubscriptionPlan.selectedProduct = maxioCompanySubscriptionStore.subscription.product;
      }
    };
    const openVerifyBankAccountModel = () => {
      if (!companySubscriptionPlan.openVerifyBankAccountModel) {
        companySubscriptionPlan.openVerifyBankAccountModel = true;
      }
    };
    const updatePaymentInformation = async () => {
      window.location.href = props.subscription?.selfServicePaymentUrl;
    };
    const subscriptionStarted = () => {
      emit('subscriptionStarted');
    };
    const cancelPickDifferentPlan = () => {
      companySubscriptionPlan.pickDifferentPlan = false;
    };
    const cancelVerifyBankAccountModel = () => {
      companySubscriptionPlan.openVerifyBankAccountModel = false;
    };
    return (_ctx, _cache) => {
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_alert = _resolveComponent("v-alert");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      return _openBlock(), _createElementBlock("div", null, [!companySubscriptionPlan.hasPaymentInformation && companySubscriptionPlan.isAwaitingSubscription ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
          'hide-block': __props.isSmallScreen
        })
      }, [_cache[1] || (_cache[1] = _createElementVNode("h3", null, "Add Payment Information", -1)), _createElementVNode("div", _hoisted_1, [_createVNode(LlSecondaryButton, {
        color: "primary",
        class: "w-52",
        onClick: updatePaymentInformation
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" Add Payment Method ", -1)]))]),
        _: 1
      })])], 2)) : _createCommentVNode("", true), companySubscriptionPlan.hasPaymentInformation && companySubscriptionPlan.isAwaitingSubscription ? (_openBlock(), _createBlock(_component_v_row, {
        key: 1
      }, {
        default: _withCtx(() => [_createVNode(_component_v_col, {
          cols: "12"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: _normalizeClass(["flex flex-row bg-gray-100 shadow-md", {
              'p-4': !__props.isSmallScreen
            }])
          }, [_createElementVNode("div", {
            class: _normalizeClass({
              'text-center p-0': __props.isSmallScreen
            })
          }, [_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("h3", {
            class: "text-black"
          }, "Payment Information", -1)), _createElementVNode("span", _hoisted_3, [_createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [__props.subscription?.card ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", null, [_cache[2] || (_cache[2] = _createElementVNode("strong", null, "Card Information:", -1)), _createTextVNode(" " + _toDisplayString(__props.subscription?.card?.description), 1)])])) : _createCommentVNode("", true), __props.subscription?.bank ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", null, [_cache[3] || (_cache[3] = _createElementVNode("strong", null, "Bank Information:", -1)), _createTextVNode(" " + _toDisplayString(__props.subscription?.bank?.description), 1)])])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_v_card_actions, {
            class: _normalizeClass({
              'flex flex-col justify-start': __props.isSmallScreen
            })
          }, {
            default: _withCtx(() => [_createVNode(LlSecondaryButton, {
              class: "w-52",
              onClick: updatePaymentInformation
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" Update Payment Method ", -1)]))]),
              _: 1
            })]),
            _: 1
          }, 8, ["class"])])])], 2), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
            class: _normalizeClass({
              'flex justify-center align-center rounded-lg border-0 mx-4 my-4 relative': !__props.isSmallScreen
            })
          }, [__props.subscription?.bank && !__props.subscription?.isAchVerified ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 0,
            type: "warning",
            dense: "",
            text: "",
            class: "flex"
          }, {
            default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("span", null, "Proceed by entering deposit amounts to complete the process.", -1)), _createElementVNode("strong", {
              text: "",
              class: "text-decoration-underline cursor-pointer",
              onClick: openVerifyBankAccountModel
            }, " Enter Deposit Amounts ")]),
            _: 1
          })) : _createCommentVNode("", true)], 2)])], 2)]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), showSelectedPlan.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(MaxioSelectedPlan, {
        subscription: __props.subscription,
        userService: __props.userService,
        state: __props.state,
        stateParams: __props.stateParams,
        interval: interval.value,
        isSmallScreen: __props.isSmallScreen,
        onPickDifferentPlan: pickDifferentPlan,
        alerts: __props.alerts,
        onStartSubscription: subscriptionStarted
      }, null, 8, ["subscription", "userService", "state", "stateParams", "interval", "isSmallScreen", "alerts"])])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", {
        class: _normalizeClass(__props.isSmallScreen ? 'flex flex-col space-y-4 items-center text-center' : 'flex items-center justify-between')
      }, [_cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "flex items-center gap-4"
      }, [_createElementVNode("h3", {
        class: "m-0"
      }, "Select Subscription Plan")], -1)), _createElementVNode("div", {
        class: _normalizeClass(__props.isSmallScreen ? 'flex flex-col space-y-2 items-center w-full' : 'flex items-center gap-2')
      }, [companySubscriptionPlan.pickDifferentPlan ? (_openBlock(), _createBlock(_component_v_card_actions, {
        key: 0,
        class: _normalizeClass(["align-center justify-center", {
          'w-full': __props.isSmallScreen
        }])
      }, {
        default: _withCtx(() => [_createVNode(LlSecondaryButton, {
          color: "primary",
          variant: "text",
          onClick: cancelPickDifferentPlan,
          class: _normalizeClass({
            'w-full': __props.isSmallScreen
          })
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Back to selected plan ", -1)]))]),
          _: 1
        }, 8, ["class"])]),
        _: 1
      }, 8, ["class"])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(__props.isSmallScreen ? 'flex justify-center w-full' : '')
      }, [_createVNode(LlButtonToggle, {
        "model-value": companySubscriptionPlan.selectedIntervalToggle,
        items: intervals,
        "aria-label": "Billing interval",
        "onUpdate:modelValue": intervalToggle
      }, null, 8, ["model-value"])], 2)], 2)], 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companySubscriptionPlan.products, (product, ids) => {
        return _openBlock(), _createElementBlock("div", {
          key: ids,
          class: "bg-gray-100 h-65 mb-10 first:rounded-t-none rounded-lg"
        }, [_createVNode(MaxioSubscriptionList, {
          product: product,
          alerts: __props.alerts,
          interval: interval.value,
          isSmallScreen: __props.isSmallScreen,
          subscription: __props.subscription,
          onSelectedSubscriptionPlan: select,
          onSubscriptionUpdated: cancelPickDifferentPlan
        }, null, 8, ["product", "alerts", "interval", "isSmallScreen", "subscription"])]);
      }), 128))])), companySubscriptionPlan.openVerifyBankAccountModel ? (_openBlock(), _createBlock(VerifyBankAccountModel, {
        key: 4,
        alerts: __props.alerts,
        onCancel: cancelVerifyBankAccountModel
      }, null, 8, ["alerts"])) : _createCommentVNode("", true)]);
    };
  }
};